// const server = "http://localhost";
// const domain = "localhost";
// const port = 9130;
const server = "https://api.oyes.lanuevatendencia.com";
const port = 443;
const domain = "admin.oyes.lanuevatendencia.com";
export { server, port, domain };
